import templateUrl from './edit-onboarding-application-modal.component.html'
import { OnboardingApplication } from '../onboarding-applications-list/onboarding-applications-list.component';


export const EditOnboardingApplicationModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controllerAs: "vm",
    controller: class EditOnboardingApplicationModalController {
        resolve: any;
        close: any;
        dismiss: any;
        application: OnboardingApplication;
        isSiteAdmin: boolean;
        showPasswordEditor: boolean;
        title: string;

        $onInit() {
            const application = this.resolve.application;
            this.application = this.resolve.application;
            this.isSiteAdmin = this.resolve.isSiteAdmin;
            this.showPasswordEditor = this.resolve.showPasswordEditor;
            this.title = !application ? 'New Onboarding Application' : 'Edit Applicant Details';
        }

        afterSubmit(application) {
            this.close({ $value: application });
        }
    }
}

export const EditOnboardingApplicationModal = {
    component: "apexEditOnboardingApplicationModal",
    controllerAs: "vm",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
